import api from "../../../api";

export const getForumKPIs = async (startDate = null, endDate = null) => {
  const params = new URLSearchParams();
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);

  const response = await api.get(`/kpis/forum?${params.toString()}`);
  return response.data;
};

export const getTransactionsKPIs = async (startDate = null, endDate = null) => {
  const params = new URLSearchParams();
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);

  const response = await api.get(`/kpis/transactions?${params.toString()}`);
  return response.data;
};
